import { makeStyles } from '@mui/styles';

export const muiStyles = makeStyles({ container: { backgroundColor: '#ffff' }});